"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        select: {
            width: '100%',
            fontSize: '0.875rem',
            '& .MuiSelect-select:focus': {
                background: 'none',
            },
            borderWidth: '1px',
            borderColor: '#d1e0ec',
            backgroundColor: '#fff',
            borderRadius: '8px',
            height: '32px',
        },
        selectionDisplay: {
            paddingTop: '8px',
            display: 'flex',
            gap: 5,
            flexWrap: 'wrap',
        },
        icon: {
            fontSize: '1.25rem',
            color: '#5d89ad',
            marginRight: '8px',
        },
        text: {
            fontSize: '0.875rem',
        },
        dropdownLabel: {
            color: '#5d89ad',
            fontSize: '12px',
            lineHeight: '16px',
            fontWeight: 600,
        },
        checkbox: {
            '& .MuiIconButton-label': {
                color: '#5d89ad',
            },
        },
        selectionTag: {
            paddingRight: '4px',
        },
        popover: {
            top: '64px !important',
        },
    });
});
